var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{staticClass:"my-0 py-0",attrs:{"color":"primary","hide-details":"","label":"One Page View"},on:{"change":_vm.onOnePageViewChange},model:{value:(_vm.onePage),callback:function ($$v) {_vm.onePage=$$v},expression:"onePage"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-796f8bf4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gt/shared/OnePageViewSwitch.vue
// module id = null
// module chunks = 